import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    width: 100%;
    height: 160px;
    margin-bottom: 24px;
    position: relative;
  `,
  image: css`
    width: 100%;
    object-fit: cover;
    object-position: 0% 0%;
    filter: blur(10px);
  `,
  buttons: css`
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 42px;
    left: 16px;
    right: 16px;
  `,
  button: css`
    &.MuiIconButton-root {
      background: rgba(112, 112, 112, 0.75) !important;
      color: ${colors.white};
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
    }
  `,
  buttonSpacing: css`
    margin-right: 8px !important;
  `,
};

export default styles;
